import api from './api';

export const getWhitePaperRequests = async () => {
  try {
    const response = await api.get('/whitepaperrequests');
    return response.data;
  } catch (error) {
    console.error('Error fetching white-paper requests:', error);
    throw error;
  }
};

export const deleteWhitePaperRequest = async (requestId) => {
  try {
    await api.delete(`/whitepaperrequests/${requestId}`);
  } catch (error) {
    console.error(`Error deleting white-paper request (ID: ${requestId}):`, error);
    throw error;
  }
};
